export default __webpack_public_path__ + "static/media/SIAINDIA.7e9575d8.png";